import { WhatAreClips } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  WhatAreClips,
  React
};